export default __webpack_public_path__ + "static/media/student-data-privacy-agreement.4e81e49a.pdf";